import { createDomainApi } from '@skylabs-digital/react-proto-kit';
import {
  tenantPreferenceInputSchema,
  tenantPreferenceSchema,
  userPreferenceInputSchema,
  userPreferenceSchema,
} from '../schemas/preference.schema';

export type {
  TenantPreference,
  TenantPreferenceInput,
  UserPreference,
  UserPreferenceInput,
} from '../schemas/preference.schema';

export const userPreferencesApi = createDomainApi(
  'preferences/users/:userId',
  userPreferenceSchema,
  userPreferenceInputSchema,
);

export const tenantPreferencesApi = createDomainApi(
  'preferences/tenants/:tenantId',
  tenantPreferenceSchema,
  tenantPreferenceInputSchema,
);
